import type { Path } from 'slate';

export const dropIds = {
  alineFooter: (tabId: UUID, pageNumber: number) => `${tabId}-footer-page${pageNumber}`,
  alineHeader: (tabId: UUID, pageNumber: number) => `${tabId}-header-page${pageNumber}`,
  alinePage: (tabId: UUID, path: Path) => `${tabId}-page-${JSON.stringify(path)}`,
  fileViewerBody: (tabId: UUID) => `${tabId}-file-viewer-body`,
} as const;
